import React from 'react';

import {
  FlexContainer,
  StyledLine,
  StyledLineInside
} from '../StyledComponents';

const commentsStyle = {
  fontSize: '1.5rem',
  color: '#212121'
};

const showCommentsStyle = {
  fontSize: '1.125rem',
  color: '#4db2ec'
};

const Comments = props => {
  // console.log('props: ', props);
  const {
    // author,
    // comments,
    count
  } = props.commentData;
  return (
    <FlexContainer direction="column" family="Montserrat">
      <StyledLine justifyContent="flex-start">
        <StyledLineInside width="90px" />
      </StyledLine>

      {/* Header column */}
      <FlexContainer
        justifycontent="space-between"
        alignitems="center"
        family="Montserrat"
      >
        <span className="normal" style={commentsStyle}>
          Comments ({count})
        </span>
        <span className="fw5 pointer dib" style={showCommentsStyle}>
          Show Comments
        </span>
      </FlexContainer>

      <StyledLine>
        <StyledLineInside />
      </StyledLine>

      {/* Load comments in this container */}
      <FlexContainer direction="column" family="Montserrat" />
    </FlexContainer>
  );
};

export default Comments;
